const HeroSection = () => {
  return (
    <section className="bg-white pt-32 pb-16 px-6 text-center">
      <div className="max-w-4xl mx-auto">
        <div className="inline-block px-4 py-2 bg-sage/10 rounded-full mb-6">
          <span className="text-xs uppercase tracking-wider text-sage font-sans font-medium">
            Get in Touch
          </span>
        </div>

        <h1 className="text-6xl font-bold text-charcoal font-serif mb-4">
          Book Your Appointment
        </h1>

        <p className="text-lg text-gray-600 font-sans">
          We're here to help you look and feel your best
        </p>
      </div>
    </section>
  );
};

export default HeroSection;